import { useState } from 'react';
const useUserCoordinates = () => {
    const [coords, setCoords] = useState(null);
    const [error, setError] = useState(null);
    const onSuccess = ({ coords: { latitude, longitude }, }) => {
        setCoords({ latitude, longitude });
    };
    const onError = ({ message }) => {
        setError(message);
    };
    const fetchUserPosition = () => {
        if (!coords) {
            const geo = navigator.geolocation;
            if (!geo) {
                setError('Geolocation is not supported');
                return;
            }
            geo.getCurrentPosition(onSuccess, onError, {
                enableHighAccuracy: false,
            });
        }
    };
    return [Object.assign(Object.assign({}, coords), { error }), fetchUserPosition];
};
export default useUserCoordinates;
//# sourceMappingURL=useUserCoords.js.map